import { useEffect, useRef, RefObject } from 'react';

type CallbackFunction = () => void;

type UseClickOutsideOptions<Inside, Trigger> = { ref: RefObject<Inside>; self: RefObject<Trigger> };

const useOutsideClick = <Inside extends HTMLElement = HTMLElement, Trigger extends HTMLElement = HTMLElement>(
  callback: CallbackFunction,
): UseClickOutsideOptions<Inside, Trigger> => {
  const ref = useRef<Inside>(null);
  const self = useRef<Trigger>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        !ref.current?.contains(event.target as Node) && // didn't click "inside"
        !self.current?.contains(event.target as Node) // and didn't click the button
      ) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [callback]);

  return { ref, self };
};

export default useOutsideClick;
